<script>
    import R, {LOADER} from "../lib/requests";
    import {API_URL, CUSTOMER_TYPE, CUSTOMER_TYPES, PAYMENT_TYPE, PAYMENT_TYPES} from "../lib/constants";
    import {lastDateOfMonth} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import DateControl from "../components/controls/DateControl.svelte";
    import MultiSelectControl from "../components/controls/MultiSelectControl.svelte";

    export let transporters = null;

    const pageHeaderControls = [
        {id: 'export', name: 'EXPORT', icon: 'file-excel'},
    ];

    let paymentTypes = [];
    let customerTypes = [];

    let search = {
        date_from: null, //'2024-01-01',
        date_to: null, // getDate('y-m-d'),
        transporter_id: '',
        customer_types: [],
        payment_types: [PAYMENT_TYPE.ON_ACCOUNT],
    }
    let report = null;

    const validate = () => {
        if (!search.date_from || !search.date_to) {
            Notifier.showError("Select dates for the report!");
            return false;
        }

        if (!search.transporter_id) {
            Notifier.showError("Select transporter for the report!");
            return false;
        }

        if (!search.customer_types.length) {
            Notifier.showError("Select customer types for the report!");
            return;
        }

        if (!search.payment_types.length) {
            Notifier.showError("Select payment types for the report!");
            return;
        }

        return true;
    }

    const load = () => {
        const onSuccess = result => {
            report = result;
        }

        const onFailure = err => {
        };

        if (!validate()) {
            return;
        }

        R.handle(R.report.transporterDetailed, search, onSuccess, onFailure, LOADER.POPUP);
    }

    const onSearch = () => {
        if (!search.date_from || !search.date_to) {
            return;
        }
        if (search.transporter_id) {
            load();
        }
    }

    const onDateFromChange = () => {
        if (!search.date_from) {
            return;
        }

        if (!search.date_to || search.date_to < search.date_from) {
            search.date_to = lastDateOfMonth(search.date_from);
        }
    }

    const onOpenTransfer = id => {
        window.open(`/app/transfer/${id}`, "_blank");
    }

    const onExport = () => {
        if (!validate()) {
            return;
        }

        const extra = `?report=transporters-detailed&` + new URLSearchParams(search);
        window.open(API_URL + '/export.php' + extra);
    }

    // init payment types
    Object.keys(PAYMENT_TYPE).map(key => {
        paymentTypes.push({
            id: PAYMENT_TYPE[key],
            name: PAYMENT_TYPES[PAYMENT_TYPE[key]],
            is_checked: search.payment_types.indexOf( PAYMENT_TYPE[key]) > -1 ? 1 : 0,
        });
    });

    // init customer types
    Object.keys(CUSTOMER_TYPE).map(key => {
        search.customer_types.push(CUSTOMER_TYPE[key]);
        customerTypes.push({
            id: CUSTOMER_TYPE[key],
            name: CUSTOMER_TYPES[CUSTOMER_TYPE[key]],
            is_checked: search.customer_types.indexOf( CUSTOMER_TYPE[key]) > -1 ? 1 : 0,
        });
    });
</script>

<PageHeader title="Transporter Detailed Report" controls={ pageHeaderControls } on:export={ onExport }/>

{#if transporters}
    <div class="panel-simple p-2 mb-4">
        <div class="row">
            <div class="col-lg-2 col-sm-3 col-6">
                <DateControl bind:value="{ search.date_from }" placeholder="from" on:change={ onDateFromChange }/>
            </div>
            <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
                <DateControl bind:value="{ search.date_to }" placeholder="to"/>
            </div>
            <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
                <select class="form-select" bind:value="{ search.transporter_id }" on:change={ onSearch }>
                    <option value="">transporter</option>
                    {#each transporters as item}
                        <option value="{ item.id }">{ item.name }</option>
                    {/each}
                </select>
            </div>
            <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
                <MultiSelectControl options="{ customerTypes }" bind:value={search.customer_types} placeholder="customer type"/>
            </div>
            <div class="col-lg-2 col-sm-3 col-6 form-group-sm">
                <MultiSelectControl options="{ paymentTypes }" bind:value={search.payment_types} placeholder="payment type"/>
            </div>
            <div class="col-xl-2 col-sm-3 col-12">
                <button class="btn btn-primary btn-block" on:click={ load }>REPORT</button>
            </div>
        </div>
    </div>
{/if}

<div class="row">
    {#if report}
        <div class="col-xl-6 col-md-12 col-12">
            <table class="table table-list table-list-border trans-account-list mb-5">
                <thead>
                <tr>
                    <th colspan="7" style="text-align: left;">
                        Period: <b>{ report.period }</b><br>
                        Transporter: <b>{ report.transporter }</b><br>
                        Kind: <b>{report.customer_type}</b><br>
                        <b>{report.payment_type}</b><br>
                    </th>
                </tr>
                </thead>
                <tbody>
                {#if report.vehicles.length}
                    {#each report.vehicles as vehicle}
                        <tr>
                            <td class="row-separator" colspan="7" style="text-align: left;"></td>
                        </tr>
                        <tr>
                            <td colspan="7"><b>{ vehicle.licence_no }</b></td>
                        </tr>
                        <tr>
                            <th>Date/Time</th>
                            <th>Transport</th>
                            <th>Kind</th>
                            <th class="text-center">Total</th>
                            <th class="text-center">A</th>
                            <th class="text-center">K</th>
                            <th>Hotel</th>
                        </tr>
                        {#each vehicle.transfers as transfer}
                            <tr>
                                <td><span class="is-link" on:click={ () => onOpenTransfer(transfer.id) }>{ transfer.date }</span></td>
                                <td>{ transfer.route_type }</td>
                                <td>{ transfer.customer_type }</td>
                                <td class="text-center">{ transfer.price }</td>
                                <td class="text-center">{ transfer.adults }</td>
                                <td class="text-center">{ transfer.children }</td>
                                <td>{ transfer.hotel }</td>
                            </tr>
                        {/each}
                        <tr>
                            <td class="row-separator" colspan="7"></td>
                        </tr>
                        <tr>
                            <td colspan="3" class="fw-semibold">Sub Totals</td>
                            <td class="fw-semibold text-center">Total</td>
                            <td class="fw-semibold text-center">Vat</td>
                            <td class="fw-semibold text-center">Net</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colspan="3"></td>
                            <td class="text-center">{ vehicle.total_price }</td>
                            <td class="text-center">{ vehicle.total_vat }</td>
                            <td class="text-center">{ vehicle.total_net }</td>
                            <td></td>
                        </tr>
                    {/each}
                    <tr>
                        <td class="row-separator" colspan="7"></td>
                    </tr>
                    <tr>
                        <td colspan="3" class="fw-semibold">Grand Total</td>
                        <td class="fw-semibold text-center">Total</td>
                        <td class="fw-semibold text-center">Vat</td>
                        <td class="fw-semibold text-center">Net</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td colspan="3"></td>
                        <td class="text-center">{ report.total_price }</td>
                        <td class="text-center">{ report.total_vat }</td>
                        <td class="text-center">{ report.total_net }</td>
                        <td></td>
                    </tr>
                {:else}
                    <tr>
                        <td colspan="7">Nothing found!</td>
                    </tr>
                {/if}
                </tbody>
            </table>
        </div>
    {/if}
</div>

<style>
    .trans-account-list .row-separator {
        height: 10px;
        padding: 0;
        background: #f2f6f8;
        /*border-left-color: #f2f6f8;*/
        /*border-right-color: #f2f6f8;*/
    }
</style>